import gql from 'graphql-tag';

import integrationItemFragment from '../fragments/integrationItemFragment';

export const queryIntegrationItemsByRemoteID = gql`
  query integrationItemsByRemoteID($remoteID: ID!) {
    integrationItemsByRemoteID(remoteID: $remoteID) {
      ...integrationItemFragment
    }
  }
  ${integrationItemFragment}
`;
export default queryIntegrationItemsByRemoteID;
